import React from 'react';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';

class SMMessageItineraryView extends React.Component {
  
  componentDidMount() {
  }
  
  render() {
    const reservation = this.props.reservation;
    const message = this.props.message;
    return (
      <div className="dashboard-message-box">
        <img src={SMRailsBridge.assetPath.serviceAdminIcon} className="dashboard-message__icon fl" alt="スペースマーケット" />
        <p className="dashboard-message-baloon dashboard-message-baloon__left dashboard-message-baloon__receive dashboard-message-baloon__spm">
          予約の成立おめでとうございます！<br />スペースマーケットより<a href={Routes.itinerary_path(reservation.uid)} target="_blank">利用日程表</a>をお送りします。参加者へシェアしたり、
          当日のアクセスの確認に利用したり、ぜひご活用ください！<br />
          <span className="dashboard-message-baloon__info">このメッセージに返信は不要です。</span>
          <a href={Routes.itinerary_path(reservation.uid)} target="_blank" className="dashboard-message-baloon__space-link">
            <span className="dashboard-message-baloon__space clearfix">
              <img src={SMFormatHelper.roomImageURL(reservation.room)} alt={SMFormatHelper.roomName(reservation.room)} className="dashboard-message-baloon__space-img" />
              <span className="dashboard-message-baloon__space-text">
                {SMFormatHelper.roomName(reservation.room)} の利用日程です。
                <span className="dashboard-message-baloon__space-title">利用日程表</span>
                <span className="dashboard-message-baloon__space-id">予約ID：{reservation.id}</span>
                <span className="dashboard-message-baloon__space-checkin">利用期間：{reservation.reserved_date_text}</span>
              </span>
            </span>
          </a>
        </p>
      </div>
    );
  }
}

export default SMMessageItineraryView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMMessageItineraryView.jsx